const subscribers = [];
export const pubsub = {
    publish: (message) => {
        subscribers.forEach(subscriber => {
            subscriber(message);
        });
    },
    subscribe: (listener) => {
        subscribers.push(listener);
    },
};
